import { useCallback, useMemo, useState } from "react";
import { useCompetitionContexts } from "shared/hooks/useCompetitionContexts";
import { useIsBriefAvailable } from "shared/hooks/api/useIsBriefAvailable";
import { FABRIC_FLOW } from "shared/pages/DesignFabric/components/FlowDropdown";
import { useAuth, useProfile } from "@brg/auth";
import { AppTester } from "supporting";

interface CommonFilter {
  limit: number;
  contexts?: string[]; 
}

const useCompetitionTabs = () => {
    const [tabsLoading, setTabsLoading] = useState(true);
    const [error, setError] = useState(false);
    const [time, setTime] = useState(0)
    const tabsName = useCompetitionContexts();
    const isGreenAward = AppTester.isGreenAward();
    const [isBriefUser, briefFlow] = useIsBriefAvailable();
    const { token } = useAuth();
    const profile = useProfile();

    const commonFilter = useMemo(() => {
      return {
        limit: 40,
        contexts: []
      } as CommonFilter
    }, []);

    const authStateIsReady =  !token ||(token && profile);

    const tabsFormatted = useMemo(() => {
        if (!authStateIsReady) {
          return [];
        }
        return tabsName?.map((tab) => {
          
          const baseFilter = {
            ...commonFilter,
            contexts: [tab],
            initWinner: true,
            initTags: true,
          };

          if (tab === 'hseanimation') {
            return {
              name: tab,
              entityType: 'jury',
              path: tab,
              filter: {
                ...baseFilter,
                contexts: ['hseanimation'],
              }
            };
          }

          if (tab === 'ratings') {
            return {
              name: tab,
              entityType: 'jury',
              path: tab,
              filter: {
                ...baseFilter,
                isRating: true
              }
            };
          }


          if (tab === 'briefs') {
            return {
              name: tab,
              entityType: 'jury',
              path: tab,
              filter: {
                ...baseFilter,
                isBriefCompetition: true,
                ...(
                  [FABRIC_FLOW.second, FABRIC_FLOW.third]?.includes(briefFlow) && 
                  { briefCompetitionFlow: briefFlow }
                )
              }
            };
          }


          return {
            name: tab,
            entityType: 'jury',
            path: tab,
            filter: baseFilter
          };
        })
    }, [commonFilter, time, tabsName, briefFlow, authStateIsReady]);

    const updateTabs = useCallback(() => {
      setTime(Date.now())
    }, [setTime])

    return {
      tabsFormatted,
      tabsLoading,
      loadingError: error,
      commonFilter,
      updateTabs,
    };
  }
;

export default useCompetitionTabs;import { useCallback, useMemo, useState } from "react";
import { useCompetitionContexts } from "shared/hooks/useCompetitionContexts";
import { useIsBriefAvailable } from "shared/hooks/api/useIsBriefAvailable";
import { FABRIC_FLOW } from "shared/pages/DesignFabric/components/FlowDropdown";
import { useAuth, useProfile } from "@brg/auth";
import { AppTester } from "supporting";

interface CommonFilter {
  limit: number;
  contexts?: string[]; 
}

const useCompetitionTabs = () => {
    const [tabsLoading, setTabsLoading] = useState(true);
    const [error, setError] = useState(false);
    const [time, setTime] = useState(0)
    const tabsName = useCompetitionContexts();
    const isGreenAward = AppTester.isGreenAward();
    const [isBriefUser, briefFlow] = useIsBriefAvailable();
    const { token } = useAuth();
    const profile = useProfile();

    const commonFilter = useMemo(() => {
      return {
        limit: 40,
        contexts: []
      } as CommonFilter
    }, []);

    const authStateIsReady =  !token ||(token && profile);

    const tabsFormatted = useMemo(() => {
        if (!authStateIsReady) {
          return [];
        }
        return tabsName?.map((tab) => {
          
          const baseFilter = {
            ...commonFilter,
            contexts: [tab],
            initWinner: true,
            initTags: true,
          };

          if (tab === 'hseanimation') {
            return {
              name: tab,
              entityType: 'jury',
              path: tab,
              filter: {
                ...baseFilter,
                contexts: ['hseanimation'],
              }
            };
          }

          if (tab === 'ratings') {
            return {
              name: tab,
              entityType: 'jury',
              path: tab,
              filter: {
                ...baseFilter,
                isRating: true
              }
            };
          }


          if (tab === 'briefs') {
            return {
              name: tab,
              entityType: 'jury',
              path: tab,
              filter: {
                ...baseFilter,
                isBriefCompetition: true,
                ...(
                  [FABRIC_FLOW.second, FABRIC_FLOW.third]?.includes(briefFlow) && 
                  { briefCompetitionFlow: briefFlow }
                )
              }
            };
          }


          return {
            name: tab,
            entityType: 'jury',
            path: tab,
            filter: baseFilter
          };
        })
    }, [commonFilter, time, tabsName, briefFlow, authStateIsReady]);

    const updateTabs = useCallback(() => {
      setTime(Date.now())
    }, [setTime])

    return {
      tabsFormatted,
      tabsLoading,
      loadingError: error,
      commonFilter,
      updateTabs,
    };
  }
;

export default useCompetitionTabs;